import React from 'react';
import USAMap from './USAMap';
import LawyersList from './LawyersList';

const MapSection = ({
  onStateClick,
  selectedState,
  selectedLawyers,
  title = 'Explora servicios verificados en Estados Unidos',
  subtitle = 'Selecciona una categoría o explora el mapa para encontrar profesionales en tu zona.',
  subtitleSecondary = 'Cada perfil publicado en nuestra plataforma ha sido validado y autorizado por el propio profesional o compañía, garantizando que la información compartida sea legítima, actualizada y respaldada por su consentimiento.',
  showHeader = true,
  useContainer = true,
  showFilters = false,
  showServiceFilter = false,
  services = [],
  selectedService = '',
  states = [],
  availableCities = [],
  selectedCity = '',
  onServiceSelect,
  onStateSelect,
  onCitySelect
}) => {
  const Inner = (
    <>
      {showHeader && (
        <div className="section-header">
          <h2 className="section-title">{title}</h2>
          <p className="section-description">{subtitle}</p>
          {subtitleSecondary && (
            <p className="section-description">{subtitleSecondary}</p>
          )}
        </div>
      )}

      {showFilters && (
        <div className="explore-filters">
          <div className="explore-filters-row">
            {showServiceFilter && (
              <div className="explore-filter">
                <label className="explore-filter-label" htmlFor="explora-servicio">Servicio</label>
                <select
                  id="explora-servicio"
                  className="explore-filter-select"
                  value={selectedService}
                  onChange={onServiceSelect}
                >
                  <option value="">Todos los servicios</option>
                  {(services || []).map((srv) => (
                    <option key={srv.key} value={srv.key}>{srv.label}</option>
                  ))}
                </select>
              </div>
            )}
            
            <div className="explore-filter">
              <label className="explore-filter-label" htmlFor="explora-estado">Estado</label>
              <select
                id="explora-estado"
                className="explore-filter-select"
                value={selectedState || ''}
                onChange={onStateSelect}
              >
                <option value="">Selecciona un estado</option>
                {(states || []).map((s) => (
                  <option key={s} value={s}>{s}</option>
                ))}
              </select>
            </div>

            <div className="explore-filter">
              <label className="explore-filter-label" htmlFor="explora-ciudad">Ciudad</label>
              <select
                id="explora-ciudad"
                className="explore-filter-select"
                value={selectedCity}
                onChange={onCitySelect}
                disabled={!selectedState || !(availableCities || []).length}
              >
                <option value="">Todas las ciudades</option>
                {(availableCities || []).map((c) => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
      )}
      
      <div className="map-content">
        <div className="map-container">
          <USAMap 
            onStateClick={onStateClick}
            selectedState={selectedState}
          />
        </div>
        <div className="lawyers-sidebar">
          <LawyersList 
            lawyers={selectedLawyers}
            stateName={selectedState}
          />
        </div>
      </div>
      
      <div className="map-disclaimer">
        <div className="disclaimer-box">
          <span className="disclaimer-icon">🔒</span>
          <div className="directory-disclaimer">
            <p className="disclaimer-content">
              <strong>GesOps valida cada perfil antes de publicarlo.</strong> Los perfiles presentes en este directorio han autorizado el uso de su información profesional y han sido verificados por nuestro equipo.
            </p>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <section className="map-section" id="mapa">
      {useContainer ? <div className="container">{Inner}</div> : Inner}
    </section>
  );
};

export default MapSection;
